import { render, staticRenderFns } from "./PatentUserSelector.vue?vue&type=template&id=c74640ba&scoped=true&"
import script from "./PatentUserSelector.vue?vue&type=script&lang=ts&"
export * from "./PatentUserSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74640ba",
  null
  
)

export default component.exports